<!--中奖记录-->
<template>
  <div class="record-prize">
    <van-popup round v-model="showprizePop" :style="{ padding: '0 24px 24px 24px' }">
      <img
        class="title"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/prizetit.png"
        alt=""
      />
      <div class="prize-list">
        <div class="nav">
          <p>中奖时间</p>
          <span>所中奖品</span>
        </div>
        <div class="list-content">
          <div class="item" v-for="(item, index) in prizeList" :key="index">
            <div class="left">{{ item.winningTime }}</div>
            <div class="right">{{ '随机奖品' }}</div>
          </div>
        </div>
        <!-- 未填写地址 -->
        <div class="adrbtn" v-if="!adrdetail.province" @click="writeAdr">填写收货地址</div>
        <!-- 已填写地址 -->
        <div v-else>
          <div class="adrtit">收货地址</div>
          <div class="adrdesc">
            <div class="item">{{ adr }}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { reqRecordUrl } from '@/api/activity/index';
export default {
  components: {},
  data() {
    return {
      showprizePop: false,
      adr: '',
    };
  },
  props: {
    prizeList: {
      type: Array,
      default: () => [],
    },
    adrdetail: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {
    adrdetail() {
      if (this.adrdetail) {
        const { province, city, area, address, phone,consignee } = this.adrdetail;
        this.adr = `${consignee}｜${phone}｜${province}${city}${area}${address}`;
      }
    },
  },

  created() {},
  mounted() {},
  methods: {
    writeAdr() {
      this.$router.push({
        path: '/tempadress',
        query: {},
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.record-prize {
  .title {
    display: block;
    width: 214px;
    height: 64px;
    margin: 0 auto 48px;
  }
  .prize-list {
    width: 486px;
    .nav {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #ffdddd;
      height: 60px;
      line-height: 60px;
      text-align: center;
      border-radius: 16px;
      p,
      span {
        width: 50%;
        font-weight: 500;
        font-size: 26px;
        color: #c4186b;
      }
    }
    .list-content {
      background: #fff3f3;
      border-radius: 0 0 16px 16px;
      padding: 40px 16px 30px 16px;
      margin-top: -16px;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        height: 55px;
        line-height: 55px;
        background: #ffffff;
        border-radius: 10px;
        margin-block: 10px;
        padding: 0 36px;
      }
    }
    .adrtit {
      position: relative;
      height: 60px;
      background: #ffdddd;
      border-radius: 16px;
      line-height: 60px;
      text-align: center;
      font-weight: 500;
      font-size: 26px;
      color: #c4186b;
      margin-top: 30px;
    }
    .adrdesc {
      background: #fff3f3;
      border-radius: 0 0 16px 16px;
      padding: 40px 16px 30px 16px;
      margin-top: -16px;
      .item {
        background: #ffffff;
        border-radius: 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 30px;
        color: #333333;
        padding: 9px 16px;
      }
    }
    .adrbtn {
      width: 260px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      background: linear-gradient(180deg, #ff6e75 0%, #ff216e 100%);
      border-radius: 40px;
      font-weight: 500;
      font-size: 32px;
      color: #ffffff;
      margin: 30px auto 0;
    }
  }
  ::v-deep {
    .van-popup--center{
      top:47%;
    }
    .van-popup--round {
      border-radius: 20px !important;
    }
  }
}
</style>
